import { Component, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: 'app-tier-header',
  templateUrl: './tier-header.component.html',
  styleUrl: './tier-header.component.scss'
})
export class TierHeaderComponent {
  /** When set, shows breadcrumb "TRENDS > {breadcrumb}" with clickable links */
  @Input() breadcrumb?: string;
  /** Route for the breadcrumb link (e.g. /transactions, /offers) */
  @Input() breadcrumbLink?: string;
}
